/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_ReportService_Dtos_Common_CommonDropdownDto } from '../models/Wealthlane_ReportService_Dtos_Common_CommonDropdownDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportAreaService {

    /**
     * @returns Wealthlane_ReportService_Dtos_Common_CommonDropdownDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppReportAreaReportAreas(): CancelablePromise<Array<Wealthlane_ReportService_Dtos_Common_CommonDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/report-area/report-areas',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
